export interface IResetPasswordResponse {
  successful: boolean;
  message: string;
}

export class ResetPasswordResponse implements IResetPasswordResponse {
  successful: boolean;
  message: string;
}
